export default {
    // 中
    zhCN: {
        system_selection: '系统选择',
        parent_dept: '上级部门',
        dept_name: '组织',
        leader: '负责人',
        email: '邮箱',
        create_by: '创建人',
        create_date: '创建时间',
        organization_editing: '组织编辑',
        phone: '电话',
        organizational_type: '组织类型',
    },
    // 英
    enUS: {
        system_selection: 'System selection',
        parent_dept: 'Parent dept',
        dept_name: 'Dept name',
        leader: 'Leader',
        email: 'Email',
        create_by: 'Create by',
        create_date: 'Create date',
        organization_editing: 'Organization editing',
        phone: 'Phone',
        organizational_type: 'Organizational type',
    },
    // 德
    deDE: {
        system_selection: 'Systemauswahl',
        parent_dept: 'Übergeordnete Abteilung',
        dept_name: 'Abteilungsname',
        leader: 'Leiter',
        email: 'E-Mail',
        create_by: 'Erstellt von',
        create_date: 'Erstellungsdatum',
        organization_editing: 'Organisation bearbeiten',
        phone: 'Telefon',
        organizational_type: 'Organisationstyp',
    },
    // 法
    frFR: {
        system_selection: 'Sélection du système',
        parent_dept: 'Département parent',
        dept_name: 'Nom du département',
        leader: 'Responsable',
        email: 'E-mail',
        create_by: 'Créé par',
        create_date: 'Date de création',
        organization_editing: 'Modification d\'organisation',
        phone: 'Téléphone',
        organizational_type: 'Type d\'organisation',
    },
    // 意大利
    itIT: {
        system_selection: 'Selezione del Sistema',
        parent_dept: 'Dipartimento Superiore',
        dept_name: 'Organizzazione',
        leader: 'Responsabile',
        email: 'Email',
        create_by: 'Creatore',
        create_date: 'Data di Creazione',
        organization_editing: 'Modifica Organizzazione',
        phone: 'Telefono',
        organizational_type: 'Tipo di Organizzazione',
    },
    // 荷兰
    nlNL: {
        system_selection: 'Systeemselectie',
        parent_dept: 'Bovenliggende afdeling',
        dept_name: 'Afdelingsnaam',
        leader: 'Leider',
        email: 'E-mail',
        create_by: 'Aangemaakt door',
        create_date: 'Aanmaakdatum',
        organization_editing: 'Organisatie bewerken',
        phone: 'Telefoon',
        organizational_type: 'Organisatietype',
    },
    // 越南
    viVN: {
        system_selection: 'Lựa chọn hệ thống',
        parent_dept: 'Bộ phận cha',
        dept_name: 'Tổ chức',
        leader: 'Người đứng đầu',
        email: 'Email',
        create_by: 'Tạo bởi',
        create_date: 'Ngày tạo',
        organization_editing: 'Chỉnh sửa tổ chức',
        phone: 'Điện thoại',
        organizational_type: 'Loại tổ chức',
    },
    // 西班牙
    esES: {
        system_selection: 'Selección del sistema',
        parent_dept: 'Departamento superior',
        dept_name: 'Organización',
        leader: 'Persona responsable',
        email: 'Correo electrónico',
        create_by: 'Creador',
        create_date: 'Fecha de creación',
        organization_editing: 'Edición de la organización',
        phone: 'Teléfono',
        organizational_type: 'Tipo de organización',
    },
    // 葡萄牙
    ptBR: {
        system_selection: 'Seleção do sistema',
        parent_dept: 'Departamento superior',
        dept_name: 'Organização',
        leader: 'Líder',
        email: 'E-mail',
        create_by: 'Criado por',
        create_date: 'Data de criação',
        organization_editing: 'Edição da organização',
        phone: 'Telefone',
        organizational_type: 'Tipo de organização',
    },
    // 波兰
    plPL: {
        system_selection: 'Wybór systemu',
        parent_dept: 'Odział nadzorujący',
        dept_name: 'Nazwa',
        leader: 'Lider',
        email: 'Email',
        create_by: 'Założone przez',
        create_date: 'Data założenia',
        organization_editing: 'Edycja organizacji',
        phone: 'Telefon',
        organizational_type: 'Typ organizacyjny',
    },
    // 土耳其
    trTR: {
        system_selection: 'Sistem seçimi',
        parent_dept: 'Bir üst departman',
        dept_name: 'Depot İsmi',
        leader: 'Yöneticisi',
        email: 'E-posta',
        create_by: 'Oluşturan kişi',
        create_date: 'Oluşturma tarihi',
        organization_editing: 'Organizasyon Düzenlemesi',
        phone: 'Telefon',
        organizational_type: 'Organizasyon türü',
    },
    // 捷克语
    csCZ: {
        system_selection: 'Výběr systému',
        parent_dept: 'Parent dept',
        dept_name: 'Název oddělení',
        leader: 'Vedoucí',
        email: 'E-mail',
        create_by: 'Vytvořil',
        create_date: 'Datum vytvoření',
        organization_editing: 'Editace organizace',
        phone: 'Telefon',
        organizational_type: 'Typ organizace',
    },
    // 匈牙利语
    huHU: {
        system_selection: 'Rendszerválasztás',
        parent_dept: 'Szülőrészleg',
        dept_name: 'Részlegnév',
        leader: 'Vezető',
        email: 'E-mail',
        create_by: 'Létrehozó',
        create_date: 'Létrehozás dátuma',
        organization_editing: 'Szervezet szerkesztése',
        phone: 'Telefon',
        organizational_type: 'Szervezeti típus',
    },
    // 俄罗斯语
    ruRU: {
        system_selection: 'Выбор системы',
        parent_dept: 'Вышестоящий отдел',
        dept_name: 'Название отдела',
        leader: 'Руководитель',
        email: 'Электронная почта',
        create_by: 'Создано',
        create_date: 'Дата создания',
        organization_editing: 'Редактирование организации',
        phone: 'Телефон',
        organizational_type: 'Тип организации',
    },
    // 沙特阿拉伯 (阿拉伯语)
    arSA: {
        system_selection: 'اختيار النظام',
        parent_dept: 'القسم الأعلى',
        dept_name: 'المنظمة',
        leader: 'المسؤول',
        email: 'البريد الإلكتروني',
        create_by: 'أنشأه',
        create_date: 'تاريخ الإنشاء',
        organization_editing: 'تحرير المنظمة',
        phone: 'الهاتف',
        organizational_type: 'نوع المنظمة',
    },
    // 保加利亚语
    bgBG: {
        system_selection: 'Избор на система',
        parent_dept: 'Родителски отдел',
        dept_name: 'Организация',
        leader: 'Ръководител',
        email: 'Имейл',
        create_by: 'Създадено от',
        create_date: 'Дата на създаване',
        organization_editing: 'Редактиране на организация',
        phone: 'Телефон',
        organizational_type: 'Тип организация',
    },
    // 丹麦语
    daDK: {
        system_selection: 'Systemvalg',
        parent_dept: 'Overordnet afdeling',
        dept_name: 'Organisation',
        leader: 'Ansvarlig',
        email: 'E-mail',
        create_by: 'Oprettet af',
        create_date: 'Oprettelsesdato',
        organization_editing: 'Redigér organisation',
        phone: 'Telefon',
        organizational_type: 'Organisationstype',
    },
    // 芬兰语
    fiFI: {
        system_selection: 'Järjestelmän valinta',
        parent_dept: 'Ylemmän tason osasto',
        dept_name: 'Organisaatio',
        leader: 'Vastuuhenkilö',
        email: 'Sähköposti',
        create_by: 'Luonut',
        create_date: 'Luontiaika',
        organization_editing: 'Organisaation muokkaus',
        phone: 'Puhelin',
        organizational_type: 'Organisaatiotyyppi',
    },
    // 繁体中文（台湾）
    zhTW: {
        system_selection: '系統選擇',
        parent_dept: '上級部門',
        dept_name: '組織',
        leader: '負責人',
        email: '電子信箱',
        create_by: '創建人',
        create_date: '創建時間',
        organization_editing: '組織編輯',
        phone: '電話',
        organizational_type: '組織類型',
    },
    // 克罗地亚语
    hrHR: {
        system_selection: 'Odabir sustava',
        parent_dept: 'Nadređeni odjel',
        dept_name: 'Organizacija',
        leader: 'Voditelj',
        email: 'E-mail',
        create_by: 'Kreirao/la',
        create_date: 'Datum stvaranja',
        organization_editing: 'Uređivanje organizacije',
        phone: 'Telefon',
        organizational_type: 'Vrsta organizacije',
    },
    // 拉脱维亚语
    lvLV: {
        system_selection: 'Sistēmas izvēle',
        parent_dept: 'Augstākā nodaļa',
        dept_name: 'Organizācija',
        leader: 'Vadītājs',
        email: 'E-pasts',
        create_by: 'Izveidoja',
        create_date: 'Izveidošanas datums',
        organization_editing: 'Organizācijas rediģēšana',
        phone: 'Tālrunis',
        organizational_type: 'Organizācijas veids',
    },
    // 立陶宛语
    ltLT: {
        system_selection: 'Sistemos pasirinkimas',
        parent_dept: 'Aukštesnis padalinys',
        dept_name: 'Organizacija',
        leader: 'Atsakingas asmuo',
        email: 'El. paštas',
        create_by: 'Sukūrė',
        create_date: 'Sukūrimo data',
        organization_editing: 'Organizacijos redagavimas',
        phone: 'Telefonas',
        organizational_type: 'Organizacijos tipas',
    },
    // 罗马尼亚语
    roRO: {
        system_selection: 'Selectare sistem',
        parent_dept: 'Departament părinte',
        dept_name: 'Organizație',
        leader: 'Responsabil',
        email: 'Email',
        create_by: 'Creat de',
        create_date: 'Data creării',
        organization_editing: 'Editare organizație',
        phone: 'Telefon',
        organizational_type: 'Tipul organizației',
    },
    // 挪威博克马尔语
    nbNO: {
        system_selection: 'Systemvalg',
        parent_dept: 'Overordnet avdeling',
        dept_name: 'Organisasjon',
        leader: 'Ansvarlig',
        email: 'E-post',
        create_by: 'Opprettet av',
        create_date: 'Opprettelsesdato',
        organization_editing: 'Rediger organisasjon',
        phone: 'Telefon',
        organizational_type: 'Organisasjonstype',
    },
    // 葡萄牙语（巴西）
    ptBX: {
        system_selection: 'Seleção do sistema',
        parent_dept: 'Departamento superior',
        dept_name: 'Organização',
        leader: 'Responsável',
        email: 'E-mail',
        create_by: 'Criado por',
        create_date: 'Data de criação',
        organization_editing: 'Edição da organização',
        phone: 'Telefone',
        organizational_type: 'Tipo de organização',
    },
    // 瑞典语
    svSE: {
        system_selection: 'Systemval',
        parent_dept: 'Överordnad avdelning',
        dept_name: 'Organisation',
        leader: 'Ansvarig',
        email: 'E-post',
        create_by: 'Skapad av',
        create_date: 'Skapelsedatum',
        organization_editing: 'Redigera organisation',
        phone: 'Telefon',
        organizational_type: 'Organisationstyp',
    },
    // 斯洛伐克语
    skSK: {
        system_selection: 'Výber systému',
        parent_dept: 'Nadradené oddelenie',
        dept_name: 'Organizácia',
        leader: 'Zodpovedná osoba',
        email: 'E-mail',
        create_by: 'Vytvoril/a',
        create_date: 'Dátum vytvorenia',
        organization_editing: 'Úprava organizácie',
        phone: 'Telefón',
        organizational_type: 'Typ organizácie',
    },
    // 斯洛文尼亚语
    slSI: {
        system_selection: 'Izbira sistema',
        parent_dept: 'Nadrejeni oddelek',
        dept_name: 'Organizacija',
        leader: 'Vodja',
        email: 'E-naslov',
        create_by: 'Ustvaril/a',
        create_date: 'Datum ustvarjanja',
        organization_editing: 'Urejanje organizacije',
        phone: 'Telefon',
        organizational_type: 'Vrsta organizacije',
    },
    // 泰语
    thTH: {
        system_selection: 'เลือกระบบ',
        parent_dept: 'หน่วยงานต้นสังกัด',
        dept_name: 'องค์กร',
        leader: 'ผู้รับผิดชอบ',
        email: 'อีเมล',
        create_by: 'สร้างโดย',
        create_date: 'วันที่สร้าง',
        organization_editing: 'แก้ไขข้อมูลองค์กร',
        phone: 'โทรศัพท์',
        organizational_type: 'ประเภทองค์กร',
    },
    // 乌克兰语
    ukUA: {
        system_selection: 'Вибір системи',
        parent_dept: 'Батьківський відділ',
        dept_name: 'Організація',
        leader: 'Керівник',
        email: 'Електронна пошта',
        create_by: 'Створив(ла)',
        create_date: 'Дата створення',
        organization_editing: 'Редагування організації',
        phone: 'Телефон',
        organizational_type: 'Тип організації',
    },
    // 希腊语
    elGR: {
        system_selection: 'Επιλογή συστήματος',
        parent_dept: 'Ανώτερο τμήμα',
        dept_name: 'Οργανισμός',
        leader: 'Υπεύθυνος',
        email: 'Ηλεκτρονικό ταχυδρομείο',
        create_by: 'Δημιουργήθηκε από',
        create_date: 'Ημερομηνία δημιουργίας',
        organization_editing: 'Επεξεργασία οργανισμού',
        phone: 'Τηλέφωνο',
        organizational_type: 'Τύπος οργανισμού',
    },
    // 爱沙尼亚语
    etEE: {
        system_selection: 'Süsteemi valik',
        parent_dept: 'Ülemosakond',
        dept_name: 'Organisatsioon',
        leader: 'Vastutaja',
        email: 'E-post',
        create_by: 'Looja',
        create_date: 'Loomise kuupäev',
        organization_editing: 'Organisatsiooni muutmine',
        phone: 'Telefon',
        organizational_type: 'Organisatsiooni tüüp',
    },
    // 哈萨克语
    kkKZ: {
        system_selection: 'Жүйені таңдау',
        parent_dept: 'Жоғары бөлім',
        dept_name: 'Ұйым',
        leader: 'Жауапты тұлға',
        email: 'Электрондық пошта',
        create_by: 'Құрастырушы',
        create_date: 'Құрылған күні',
        organization_editing: 'Ұйымды түзету',
        phone: 'Телефон',
        organizational_type: 'Ұйым түрі',
    },
    // 希伯来语
    heIL: {
        system_selection: 'בחירת מערכת',
        parent_dept: 'המחלקה העליונה',
        dept_name: 'ארגון',
        leader: 'אחראי',
        email: 'דוא"ל',
        create_by: 'נוצר על ידי',
        create_date: 'תאריך יצירה',
        organization_editing: 'עריכת ארגון',
        phone: 'טלפון',
        organizational_type: 'סוג הארגון',
    },
};
